import { render, staticRenderFns } from "./importFreightTemplateModal.vue?vue&type=template&id=87d7fd34&scoped=true"
import script from "./importFreightTemplateModal.vue?vue&type=script&lang=js"
export * from "./importFreightTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d7fd34",
  null
  
)

export default component.exports